/* tslint:disable */
const VERSION = "9523298053130be6fb7ab872c9063a57ce3652f3 Mon Jul 14 09:57:30 2025 +0200";
module.exports = { VERSION }
